export type ProjectHourNoteInput = {
  project_hour_id: number
  text: string
}

export const buildProjectHourNotes = (formValues: Record<string, string>): ProjectHourNoteInput[] => {
  return Object.entries(formValues).map(([projectHourId, text]) => ({
    project_hour_id: +projectHourId,
    text: text ?? '',
  }))
}

// Mirrors Drupal\skvr_hour\Entity\ProjectHourComment::getTransitionIdDisplayValue()
// in the skvr-zp backend (web/modules/custom/skvr_hour/src/Entity/ProjectHourComment.php).
const STATE_TRANSITION_LABELS: Record<string, string> = {
  confirmed: 'Bevestigd',
  rejected: 'Afgewezen',
  neutral: 'Geen statuswijziging',
}

export const getStateTransitionLabel = (stateTransition?: string | null): string =>
  STATE_TRANSITION_LABELS[stateTransition ?? ''] ?? ''

// Reuses the app's existing hour-status colors (HourStatuses.php: accepted ->
// success, rejected -> error, draft/sent -> the default/info Chip color)
// rather than introducing a new palette for comment badges.
export type StateTransitionColor = 'success' | 'error' | 'info'

const STATE_TRANSITION_COLORS: Record<string, StateTransitionColor> = {
  confirmed: 'success',
  rejected: 'error',
  neutral: 'info',
}

export const getStateTransitionColor = (stateTransition?: string | null): StateTransitionColor | undefined =>
  STATE_TRANSITION_COLORS[stateTransition ?? '']
